interface Props {
  label: string;
  value: number | string;
  sub?: string;
  /** Évolution vs période précédente, déjà formatée (« ▲ +11 % vs … »). */
  delta?: string | null;
  /** Part de 0 à 100 affichée sous la valeur. */
  meter?: number;
}

export function KpiCard({ label, value, sub, delta, meter }: Props) {
  return (
    <div className="ci-kpi">
      <div className="ci-kpi__label">{label}</div>
      <div className="ci-kpi__value">{value}</div>
      {meter !== undefined && (
        <div className="ci-meter" role="img" aria-label={`${meter} %`}>
          <div className="ci-meter__fill" style={{ width: `${Math.max(0, Math.min(100, meter))}%` }} />
        </div>
      )}
      {sub && <div className="ci-kpi__sub">{sub}</div>}
      {delta && <div className="ci-kpi__delta">{delta}</div>}
    </div>
  );
}
